export default "/images/orange_arrow_blue_border_reverse.png?44ac0fc88765c7c54f5864e0f40bae0a";